angular.module('salesPath2')
  .service('verifyInfoModalHelper', [
    function() {
        var VerifyInfoModalHelper = function() {}; // NOSONAR
        return new VerifyInfoModalHelper();
    }
  ]);